export const pin = "pbb";
export default {pin};